import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API, LOCAL_TOKEN_KEY } from "@/lib/api";

const LocalAuthCtx = createContext({ user: null, loading: true });
export const useLocalAuth = () => useContext(LocalAuthCtx);

export function LocalAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(() => !!localStorage.getItem(LOCAL_TOKEN_KEY));

  useEffect(() => {
    const token = localStorage.getItem(LOCAL_TOKEN_KEY);
    if (!token) { setLoading(false); return; }
    axios.get(`${API}/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setUser(data.user))
      .catch(() => localStorage.removeItem(LOCAL_TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const login = (data) => {
    localStorage.setItem(LOCAL_TOKEN_KEY, data.access_token);
    setUser({ user_id: data.user_id, email: data.email, name: data.name, role: data.role });
  };
  const logout = () => {
    localStorage.removeItem(LOCAL_TOKEN_KEY);
    axios.post(`${API}/auth/logout`).catch(() => {});
    setUser(null);
  };

  return <LocalAuthCtx.Provider value={{ user, loading, login, logout }}>{children}</LocalAuthCtx.Provider>;
}
